import "../projects.css";
import ProjectCard from "./ProjectCard";
import { isLoaded } from "react-redux-firebase";
import styled from "styled-components";

const sortDate = (array, key) => {
  array.sort((a, b) => new Date(b.created) - new Date(a.created));
};

const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 20px 0;
  width: 100%;
`;

const Projects = ({
  projects,
  handleClick,
  handleDelete,
  handleEdit,
  edit,
}) => {
  let sortedProjects = projects;
  if (isLoaded(projects)) {
    sortDate(sortedProjects);
    return (
      <ListContainer>
        {sortedProjects.map((project, index) => (
          <ProjectCard
            handleEdit={handleEdit}
            project={project}
            key={index}
            index={index}
            handleClick={handleClick}
            handleDelete={handleDelete}
            edit={edit}
          />
        ))}
      </ListContainer>
    );
  } else {
    return (
      <div className="lds-ellipsis mx-auto my-5">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    );
  }
};

export default Projects;
